import { awaitRequests, promise } from '../../../helpers';
import { saveTaskFiles } from '.';
import { getGroupsParticipantsItem } from '../groups-participants';
import { upsertScheduleForAssignment } from '../schedules';

const addTask = ({ data, uploadList }) => {
    return (dispatch, getState, getFirebase) => {
        // -- add
        const add = d => {
            return getFirebase()
                .firestore()
                .collection('tasks')
                .add(d)
                .then(docRef => promise({ ...d, id: docRef.id }));
        };

        // after add
        const afterAdd = async item => {
            const reqs = [];

            // upload files
            reqs.push(dispatch(saveTaskFiles(item, uploadList)));
            if (item.groupId) {
                const requestParticipants = await dispatch(
                    getGroupsParticipantsItem({ where: [['groupId', '==', item.groupId]] }),
                );
                if (requestParticipants.participantsIds) {
                    reqs.push(dispatch(upsertScheduleForAssignment(item, requestParticipants.participantsIds, 'task')));
                }
            }

            return awaitRequests(reqs).then(() => promise(item));
        };

        // --
        if (data) {
            return add(data).then(item => afterAdd(item));
        }

        return promise();
    };
};

export default addTask;
